import { defineMessages } from 'react-intl';

export default defineMessages({
  automationRuleLabelText: {
    description: 'Text displayed to the user to describe the automation rule label',
    defaultMessage: '{ruleCount, plural,=0 {Automation Rule Usage (#)} one {Automation Rule Usage} other {Automation Rule Usage (#)}}',
    id: 'r+bx9n',
  },
  automationRuleExpanderAriaLabel: {
    description: 'Aria label for the automation rule expander',
    defaultMessage: 'Expand Automation Rules',
    id: 'PMreqc',
  },
});
